/** Only used when resourceFirstArchitectureDemo flag is on */
import { type Common } from '../common.js';
import {
  type CreateResourceFlowTrigger,
  type ResourceFlowTrigger,
  type ResourceFlowTriggerFindAllOptions,
} from '../models/resourceGateway/resourceFlowTrigger.js';

export class API {
  common: Common;
  baseEndpoint = '/resource-gateway/resource-trigger/watch';
  resourceTriggerBase = '/resource-gateway/resource-trigger';

  constructor(common: Common) {
    this.common = common;
  }

  async getResourceTypes(): Promise<string[]> {
    const url = this.common.constructPath(`${this.resourceTriggerBase}/resource-types`);
    return await this.common.getJSON(url);
  }

  async findAll(queryParams: ResourceFlowTriggerFindAllOptions): Promise<ResourceFlowTrigger[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async create(values: CreateResourceFlowTrigger): Promise<{ id: string }> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async delete(id: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    await this.common.deleteJSON(url);
  }
}
